import { i18nFilter } from "app/filters/i18nFilter";
import React from "react";
import _ from "lodash";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { Widget } from "../widget-types/Widget";
import { StatefulDropdown } from "app/components/dashboard/widget-wizard/components/StatefulDropdown";
import DashboardCategoryItem from "app/components/dashboard/widget-wizard/components/DashboardCategoryItem";
import categoryService from "app/common/services/categoryService";
import {
    getInitialItemArray,
    BooleanSearchWithBothKeywordsAndWebsiteWrapper,
} from "app/pages/website-analysis/traffic-sources/search/BooleanSearchWithBothKeywordsAndWebsiteWrapper";
import { EBooleanSearchActions } from "app/pages/website-analysis/traffic-sources/search/BooleanSearchWithBothKeywordsAndWebsite";
import type { IBooleanSearchChipItem } from "@similarweb/ui-components";
import { booleanSearchChipsObjectToApiParams } from "app/pages/website-analysis/traffic-sources/search/booleanSearchUtility";
import { BooleanSearchWrapper } from "../widget-types/TableSearchKeywordsDashboardWidgetFilters";
import { EBooleanSearchActionsTypes } from "@similarweb/ui-components";
import { BooleanSearchInput } from "@similarweb/ui-components";
import styled from "styled-components";
const BooleanSearchContainer = styled(BooleanSearchWrapper)`
    ${BooleanSearchInput} {
        line-height: 42px;
    }
`;
export class TopReferralsDashboardTableWidgetFilters extends React.Component<any, any> {
    protected selectedFilters: any = {};

    constructor(props) {
        super(props);
        const staticCategories = categoryService.getCategories();
        this.state = {
            clearValue: false,
            dynamicCategories: this.getCategories(staticCategories),
        };
        this.selectedFilters = {
            filter:
                this.removeQuotes(this.getInitialSelection()["domain"] && this.getInitialSelection()["domain"].value) ||
                props.widgetFilters.filter,
            orderBy: props.widgetFilters.orderBy || "TotalShare desc",
            Category:
                this.props.widgetFilters.Category ||
                this.removeQuotes(
                    this.getInitialSelection()["category"] && this.getInitialSelection()["category"].value,
                ) ||
                "All",
            includeSubDomains: this.props.widgetFilters.includeSubDomains,
        };
        if (props.widgetFilters.ExcludeUrls) {
            this.selectedFilters.ExcludeUrls = props.widgetFilters.ExcludeUrls;
        }
        if (props.widgetFilters.IncludeUrls) {
            this.selectedFilters.IncludeUrls = props.widgetFilters.IncludeUrls;
        }
        this.getSelectedFilters("fromState") && props.changeFilter(this.getSelectedFilters("fromState"));
    }

    public componentDidUpdate(prevProps) {
        //TODO: Add available categories to backend response
        /*        if (newProps.widgetPreview && newProps.widgetPreview !== this.state.dynamicCategories && newProps.widgetPreview.Filters) {
            let _newCategories = [{id: "0", text: "All Categories"}, ...newProps.widgetPreview.Filters.category];
            if (this.props.widgetFilters.Category === undefined || (this.props.widgetFilters.Category !== newProps.widgetFilters.Category)) {
                this.setState({
                    dynamicCategories: this.getCategories(_newCategories),
                    Category: this.selectedFilters.Category || "0",
                });
            }else{
                this.setState({dynamicCategories: this.getCategories(_newCategories)});
            }
            this.selectedFilters = {
                filter: newProps.widgetFilters.filter,
                orderBy: newProps.widgetFilters.orderBy || "TotalShare desc",
                Category: this.selectedFilters.Category || "0",
            };
        }*/
        if (this.props.widgetMetric !== prevProps.widgetMetric) {
            this.setState({ clearValue: true });
            setTimeout(() => {
                this.setState({ clearValue: false });
            });
        }
    }

    private getCategories(apiCategories) {
        const categories = [];
        if (apiCategories) {
            apiCategories.forEach((category) => {
                categories.push(category);
                if (category.children) {
                    category.children.forEach((child) => {
                        categories.push(child);
                    });
                }
            });
        }
        return categories;
    }

    private getInitialSelection() {
        const widgetFilters = this.props.widgetFilters.filter;
        if (typeof widgetFilters === "string" && widgetFilters) {
            return Widget.filterParse(widgetFilters);
        } else {
            return "0";
        }
    }

    private removeQuotes(string) {
        return string && string.replace(/"/g, "");
    }

    private getSearchValue() {
        if (
            typeof this.selectedFilters.filter === "string" &&
            this.selectedFilters.filter &&
            this.selectedFilters.filter.indexOf(";") > 0
        ) {
            const filterObject: any = Widget.filterParse(this.selectedFilters.filter);
            const filterObjectItem: any = filterObject["domain"];
            return filterObjectItem && filterObjectItem.hasOwnProperty("value")
                ? filterObjectItem.value.replace(/"/g, "")
                : "";
        } else {
            return typeof this.selectedFilters.filter === "string" ? this.selectedFilters.filter : "";
        }
    }

    private getSelectedFilters(newCategory?) {
        if (!newCategory) {
            return this.selectedFilters["filter"];
        }
        const filters = [];
        for (const filter in this.selectedFilters) {
            let _value = this.selectedFilters[filter];
            if (filter === "filter") {
                const _textFilter = this.getSearchValue() ? `domain;contains;"${this.getSearchValue()}",` : "";
                let _categoryFilter;

                switch (newCategory) {
                    case "All":
                        _categoryFilter = "";
                        break;
                    case "fromState":
                        if (this.selectedFilters.Category === "0") {
                            _categoryFilter = "";
                            break;
                        }
                        _categoryFilter =
                            this.selectedFilters.Category && this.selectedFilters.Category != "All"
                                ? `category;category;"${this.selectedFilters.Category}",`
                                : "";
                        break;
                    default:
                        _categoryFilter = newCategory ? `category;category;"${newCategory}",` : "";
                }

                _value = `${_textFilter}${_categoryFilter}`;
                _value = _.trim(_value, ",");
                this.setState({ filter: _value });
            }
            filters.push({ name: filter, value: _value });
        }
        return filters;
    }

    private onSelectCategory = (item) => {
        this.selectedFilters.Category = item.id;
        this.props.changeFilter(this.getSelectedFilters(item.id));
    };

    private onSelectOrderBy = (item) => {
        this.selectedFilters.orderBy = item.id;
        this.props.changeFilter(this.getSelectedFilters("fromState"));
    };

    private onSelectincludeSubDomains = (item) => {
        this.selectedFilters.includeSubDomains = item.id;
        this.props.changeFilter(this.getSelectedFilters("fromState"));
    };

    private onSearch = (chipsObject: IBooleanSearchChipItem[]) => {
        const { IncludeUrls, ExcludeUrls } = booleanSearchChipsObjectToApiParams(chipsObject);
        if (IncludeUrls === "") {
            delete this.selectedFilters.IncludeUrls;
        } else {
            this.selectedFilters.IncludeUrls = IncludeUrls;
        }
        if (ExcludeUrls === "") {
            delete this.selectedFilters.ExcludeUrls;
        } else {
            this.selectedFilters.ExcludeUrls = ExcludeUrls;
        }
        this.props.changeFilter(this.getSelectedFilters("fromState"));
    };

    private booleanSearchApiParamsToChips = ({ ExcludeUrls: excludeUrls, IncludeUrls: includeUrls }) => {
        const excludeUrlsArray = getInitialItemArray(EBooleanSearchActionsTypes.excludeUrl)(excludeUrls);
        const includeUrlsArray = getInitialItemArray(EBooleanSearchActionsTypes.includeUrl)(includeUrls);
        const logicalSeparator = {
            text: "AND",
            action: "logicalSeparator",
            id: "logicalSeparator",
        };
        return [
            ...includeUrlsArray,
            includeUrlsArray.length > 0 && excludeUrlsArray.length > 0 && logicalSeparator,
            ...excludeUrlsArray,
        ];
    };

    render() {
        const _searchChannels =
            this.state.dynamicCategories.length > 0 ? (
                <div
                    key="searchChannel"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.category`}</I18n>
                    </h5>
                    <StatefulDropdown
                        key="categoryFilter"
                        items={this.state.dynamicCategories}
                        selectedId={this.selectedFilters.Category}
                        onSelect={this.onSelectCategory}
                        DropDownItemComponent={DashboardCategoryItem}
                        hasSearch={true}
                        searchPlaceHolder={i18nFilter()("home.dashboards.wizard.filters.searchCategory")}
                    />
                </div>
            ) : null;
        return (
            <>
                <div
                    key="dynamicFiltersContainer"
                    className="filters"
                >
                    {_searchChannels}
                    <div
                        key="orderby"
                        className="dynamicFilter"
                    >
                        <h5>
                            <I18n>{`home.dashboards.wizard.filters.orderBy`}</I18n>
                        </h5>
                        <StatefulDropdown
                            key="orderbyFilter"
                            items={[
                                { id: "TotalShare desc", text: "Traffic Share" },
                                { id: "Change desc", text: "Change" },
                            ]}
                            selectedId={this.selectedFilters.orderBy}
                            onSelect={this.onSelectOrderBy}
                        />
                    </div>
                    <div
                        key="includeSubDomains"
                        className="dynamicFilter"
                    >
                        <h5>
                            <I18n>{`home.dashboards.wizard.filters.includeSubDomains`}</I18n>
                        </h5>
                        <StatefulDropdown
                            key="includeSubDomainsFilter"
                            items={[
                                { id: "true", text: "Yes" },
                                { id: "false", text: "No" },
                            ]}
                            selectedId={this.selectedFilters.includeSubDomains}
                            onSelect={this.onSelectincludeSubDomains}
                        />
                    </div>
                </div>
                <div
                    key="searchterm"
                    className="filter"
                    style={{ flexDirection: "column" }}
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.searchterm`}</I18n>
                    </h5>
                    <BooleanSearchContainer>
                        <BooleanSearchWithBothKeywordsAndWebsiteWrapper
                            onChange={this.onSearch}
                            chips={this.booleanSearchApiParamsToChips({
                                IncludeUrls: this.selectedFilters.IncludeUrls,
                                ExcludeUrls: this.selectedFilters.ExcludeUrls,
                            })}
                            booleanSearchAction={EBooleanSearchActions.WEBSITES}
                        />
                    </BooleanSearchContainer>
                </div>
            </>
        );
    }
}
